import React, { useEffect, useRef, useState } from "react";
import "../../../src/App.scss";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useHistory } from "react-router-dom";
import QRScan from "qrscan";
import { useTranslation } from 'react-i18next';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { dataService } from "../../Services/data/data.service";
import { toast } from "react-toastify";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Input from "@mui/material/Input";
import Quagga from 'quagga';
import { BiBarcodeReader } from 'react-icons/bi';
import { DialogTitle, IconButton } from '@mui/material';
import { Typography } from "@material-ui/core";
import i18n from 'i18next';


function PickingDetail(props) {
  /* Hooks section start */
  const { t } = useTranslation();

  const [getListData, setListData] = useState(props.location.state.listDetail);
  const [getAllPausedData, setAllPausedData] = useState(props.location.state.pausedDetailList);
  const [getCount, setCount] = useState(1);
  const [openScanner, setOpenScanner] = useState(false);
  const [openItemPickedDialog, setOpenItemPickedDialog] = useState(false);
  const [openQuantityDeficit, setOpenQuantityDeficit] = useState(false);
  const [openQuantitySurplus, setOpenQuantitySurplus] = useState(false)
  const [openEndCartDialogOne, setOpenEndCartDialogOne] = useState(false);
  const [openEndCartDialogSecond, setOpenEndCartDialogSecond] = useState(false);
  const [openWaitingZoneDialog, setOpenWaitingZoneDialog] = useState(false);
  const [openItemNotPickedDialog, setOpenItemNotPickedDialog] = useState(false);
  const [reasonItemNotPickedStockAmount, setReasonItemNotPickedStockAmount] = useState(false)
  const [reasonItemNotPickedWrongBarcode, setReasonItemNotPickedWrongBarcode] = useState(false)
  const [reasonItemNotPickedUnknown, setReasonItemNotPickedUnknown] = useState(false)
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false);
  const [openDialogWhenAllItemsPicked, setOpenDialogWhenAllItemsPicked] = useState(false);
  const [popupEnable, setPopupEnable] = useState(true);
  const [popupItemEnable, setPopupItemEnable] = useState(true);
  const [popupEndCartEnableOne, setPopupEndCartEnableOne] = useState(true);
  const [pickedStockItems, setPickedStock] = useState([]);
  const [getCheckedList, setCheckedList] = useState([]);
  const [getCheckeEndCartBtn, setCheckeEndCartBtn] = useState(true);
  const [showTableList, setShowTableList] = useState(false);
  const [showLocation, setshowLocation] = useState("");
  const [showProductDescription, setShowProductDescription] = useState("");
  const [getProgressPercentage, setProgressPercentage] = useState(0);
  const [productToBePickedIndex, setProductToBePickedIndex] = useState(null);
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [getEndCartBtnFlag, setEndCartBtnFlag] = useState(true);
  const [getPercentagePerItem, setPercentagePerItem] = useState(0);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [getProductIdList, setProductIdList] = useState([]);
  const [debounceTimer, setDebounceTimer] = useState(null);

  const [scannerStarted, setScannerStarted] = useState(false);
  const [barcode, setBarcode] = useState('');

  const firstUpdate = useRef(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amountValue, setAmountValue] = useState(0);
  const [productDescription, setProductDescription] = useState("");
  const [productLocation, setProductLocation] = useState("");
  let history = useHistory();
  /* Global variables */

  useEffect(() => {
    // setListData()
    if (checkedProducts.length === 0) {
      setCheckedProducts(props.location.state.tempArr);
    }

    var percentageCalulated = calculatePercentage();

    setPercentagePerItem(100 / percentageCalulated);
    getDataForCarrier(100 / percentageCalulated);
    endCartButtonDeactivateOrActivate();
  }, [props.location.state.tempArr]);


  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (scannerStarted) startScanner();
    else stopScanner();
  }, [scannerStarted]);

  /* Hooks section end */



  /* Handler functions section start */

  /** To navigate on Scanner screen */

  const goToScanner = () => {
    var cartNumber = showCartNumber();

    history.push({
      pathname: "/scannerpage",
      state: {
        previousCartCode: cartNumber,
        pausedDetailList: getAllPausedData,
        listDetail: getListData,
        checkNavigation: "PickingDetail",
        checkedList: getCheckedList,
        tempArr: checkedProducts
      },
    });
  };

  const handleAddCount = () => {
    setCount(getCount + 1);
  };

  const handleSubtractCount = () => {
    if (getCount > 1) {
      setCount(getCount - 1);
    }
  };
  const handleChangeCount = (input) => {
    var value = parseInt(input.target.value);
    setCount(value);
  };

  /* For scanner open dialog */
  const handleClickOpenScanner = () => {
    setOpenScanner(true);
    setTimeout(() => {
      setScannerStarted(!scannerStarted)
    }, 0)
  };

  const handleCloseScanner = () => {
    setOpenScanner(false);
    setScannerStarted(!scannerStarted)
  };

  // close dialog
  const handleCloseItemDialog = () => {
    setOpenItemPickedDialog(false);
  };

  // close dialog
  const handleOpenQuantityDeficit = () => {
    var temp = openQuantityDeficit;
    setOpenQuantityDeficit(!temp);
  };

  const handleOpenQuantitySurplus = () => {
    var temp = openQuantitySurplus;

    setOpenQuantitySurplus(!temp);
  };


  /* For End cart first dialog */
  // open dialog
  const handleClickOpenEndCartCompleteListDialog = () => {
    setOpenEndCartDialogOne(true);
    // setOpenEndCartDialogThird(true)
  };

  // close dialog
  const handleCloseEndCartDialogOne = () => {
    setOpenEndCartDialogOne(false);
    // history.push({pathname:'/'})
  };

  /* For End cart second dialog */
  // open dialog
  const handleClickOpenEndCartDialog = () => {
    setOpenEndCartDialogSecond(true);
    setPopupEndCartEnableOne(false);
  };

  const handleGoBackToMainMenu = () => {
    history.push({ pathname: "/" });

  }

  // close dialog
  const handleCloseEndCartDialogSecond = () => {
    setOpenEndCartDialogSecond(false);
  };


  /* Calling sendPauseWorkflow Api */
  const handlePausedWorkflow = async () => {
    await dataService.sendPauseWorkflow(getListData.id).then((result) => {
      setOpenWaitingZoneDialog(false);
      history.push({ pathname: "/" });
    })
      .catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });

  };

  const handleWaitingZoneDialogOpen = async () => {
    await dataService.sendValidateUser(userName, password).then((stations) => {
      if (stations) {
        setOpenEndCartDialogOne(false);
        setOpenWaitingZoneDialog(true);
      } else {
        setOpenVerificationDialog(true)
        handleCloseEndCartDialogOne();
      }
    })
      .catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });

  };


  const handleItemNotPickedDialogClose = async () => {
    setOpenItemNotPickedDialog(false);
  };

  /* Calling sendFinishWorkflow Api */
  const handleFinishedWorkflow = async () => {
    if (!debounceTimer) {
      await dataService.sendFinishWorkflow(getListData.id).then((result) => {
        if (result) {
          handleCloseEndCartDialogSecond();
        }
      }).catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });
      history.push({ pathname: "/" });

      setDebounceTimer(setTimeout(() => {
        setDebounceTimer(null);
      }, 10000))
    }
  };

  /* For item picking dialog */
  // open dialog
  const handleClickOpenItemDialog = () => {
    if (getCount === amountValue && barcode != '') {
      setOpenItemPickedDialog(true);
    }

    if (getCount < amountValue) {
      setOpenQuantityDeficit(true);
    }

    if (getCount > amountValue) {
      setOpenQuantitySurplus(true)
    }

    else if (barcode === '') {
      // alert('barcode is required')
      alert('Barcode vereist')
    }

  };

  const handleItemPicked = async () => {
    setCount(1);
    var tempPickingList = { ...getListData };
    var materialType = JSON.parse(tempPickingList.workflowSteps[0].workflowStepDetails[productToBePickedIndex].metaData).find(y => y.MetaDataType === 1).MetaData[0].Type;
    var workFlowStepDetailId = tempPickingList.workflowSteps[0].workflowStepDetails[productToBePickedIndex].id;
    var tempCheckedProducts = [...checkedProducts];
    var tempPickedStock = [...pickedStockItems];

    var cartNumber = showCartNumber();
    await dataService.getPickStock(barcode, cartNumber, amountValue, tempPickingList.id, materialType, workFlowStepDetailId).then((result) => {
      setBarcode("");
      let flagRes = result;
      if (flagRes.success) {
        // item picked successfully
        tempPickingList.workflowSteps[0].workflowStepDetails[productToBePickedIndex].finishedOn = new Date();
        tempCheckedProducts[productToBePickedIndex] = true;
        var indexFound = false;
        tempPickingList.workflowSteps[0].workflowStepDetails.map((nextPicking, nextIndex) => {
          if (nextPicking.finishedOn === null && indexFound === false && productToBePickedIndex !== nextIndex) {
            setProductToBePickedIndex(nextIndex);
            indexFound = true;
          }
        })

        endCartButtonDeactivateOrActivate();
        let allitemPicked = true;
        tempCheckedProducts.map((item) => {
          if (!item) {
            allitemPicked = false;
          }
        })
        setListData(tempPickingList);
        setCheckedProducts(tempCheckedProducts);

        setCheckeEndCartBtn(false);
        handleCloseItemDialog();
        showProducts();
        let x = handleProgressCalculation(amountValue, getPercentagePerItem, getProgressPercentage);
        setProgressPercentage(x);
        if (allitemPicked) {
          setOpenDialogWhenAllItemsPicked(true);
        }

      } else {
        // item could not be picked
        if (flagRes.wrongBarcode) {
          setReasonItemNotPickedWrongBarcode(true);
          setReasonItemNotPickedUnknown(false);
          setReasonItemNotPickedStockAmount(false);
        }
        else if (flagRes.insufficientStock) {
          setReasonItemNotPickedWrongBarcode(false);
          setReasonItemNotPickedUnknown(false);
          setReasonItemNotPickedStockAmount(true);
        }
        else {
          setReasonItemNotPickedWrongBarcode(false);
          setReasonItemNotPickedUnknown(true);
          setReasonItemNotPickedStockAmount(false);
        }
        handleCloseItemDialog();
        setOpenItemNotPickedDialog(true);
      }
    }).catch((error) => {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
    });
  };

  /* Handler functions section end */


  /* Scanning functionality START  */

  const startScanner = () => {
    Quagga.init(
      {
        inputStream: {
          type: 'LiveStream',
          target: document.querySelector('#scanner-container'),
          constraints: {
            facingMode: 'environment' // or user
          }
        },
        numOfWorkers: navigator.hardwareConcurrency,
        locate: true,
        frequency: 1,
        debug: { drawBoundingBox: true, showFrequency: true, drawScanline: true, showPattern: true },
        multiple: false, locator: {
          halfSample: false,
          patchSize: 'large',
          debug: { showCanvas: false, showPatches: false, showFoundPatches: false, showSkeleton: false, showLabels: false, showPatchLabels: false, showRemainingPatchLabels: false, boxFromPatches: { showTransformed: false, showTransformedBox: false, showBB: false } }
        }, decoder: { readers: props.readers }
      }, err => {
        if (err) { return console.log(err); } Quagga.start();
      }
    );
    Quagga.onDetected(_onDetected);
    Quagga.onProcessed(result => {
      let drawingCtx = Quagga.canvas.ctx.overlay, drawingCanvas = Quagga.canvas.dom.overlay;
      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
          result.boxes.filter(box => box !== result.box).forEach(box => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
          });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
        }
      }
    });
  };

  const stopScanner = () => {
    Quagga.offProcessed();
    Quagga.offDetected();
    Quagga.stop();
  };

  const _onDetected = res => {
    if (res.codeResult.code) {
      var barcodeValue = res.codeResult.code;
      barcodeValue = barcodeValue.replace(/\s/g, '');
      setBarcode(barcodeValue);
      setScannerStarted(false);
      setOpenScanner(false);
    }
  };

  /* Scanning functionality END  */

  /* Render functions start*/
  const showCartNumber = () => {
    let metaData = JSON.parse(getListData.workflowSteps[0].metaData);
    return metaData[0].MetaData[0].CartNumber;
  };

  /** Show the list of products */
  const showProducts = () => {
    return getListData.workflowSteps[0].workflowStepDetails.sort((a, b) => a.id - b.id).map((workflowStepDetail, workflowStepDetailIndex) => {
      let metaData = JSON.parse(workflowStepDetail.metaData);
      let amount = metaData[0].MetaData[0].Amount;
      var pickitem = workflowStepDetail.workflowProductDetailModel;
      var error = false;
      var warning = false;
      if (((pickitem.articleId !== null && pickitem.articleId !== '') && pickitem.barcode === null)) {
        error = true;
      }
      if ((pickitem.articleId === null || pickitem.articleId === '') && (pickitem.barcode === null || pickitem.barcode === '')) {
          warning = true;
      }

      return (
        <tr key={"productList_" + workflowStepDetailIndex} style={{ background: (error ? 'rgb(217, 150, 153)' : (warning ? 'rgb(235, 187, 136)' : 'none')) }}>
          <td className="pointer-event-none">
            <input type="checkbox" checked={checkedProducts[workflowStepDetailIndex]} readOnly />
          </td>
          <td style={{ fontWeight: workflowStepDetailIndex === productToBePickedIndex && 700 }}>{workflowStepDetail.workflowProductDetailModel.productReference}</td>
          <td>{amount} {t('st')}</td>
        </tr>
      );
    }
    );
  };

  /** Show percentage on progress bar */
  const handleProgressCalculation = (amount, ppi, pp) => {
    let newPercentage = ppi * amount;
    return pp + newPercentage;
  };



  /* Show Picking assignment */
  const showPickingAssignment = () => {
    if (productToBePickedIndex !== null) {
      var tempProductDescription = "";
      var tempLocation = "";

      var tempAmountValue = 0;
      if (getListData.workflowSteps[0].workflowStepDetails.length > productToBePickedIndex) {
        let item = getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex];
        let metaData = JSON.parse(item.metaData);
        tempAmountValue = metaData[0].MetaData[0].Amount;
        tempProductDescription = getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex].workflowProductDetailModel.productReference;
        tempLocation = getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex].workflowProductDetailModel.location !== "" && getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex].workflowProductDetailModel.location !== null ? getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex].workflowProductDetailModel.location : "-";
      } else {
        tempAmountValue = 0;
        tempProductDescription = "";
      }
      var error = false;
      var warning = false;
      var pickitem = getListData.workflowSteps[0].workflowStepDetails[productToBePickedIndex].workflowProductDetailModel;
      console.log('pickITems Detail ', pickitem)

      if (((pickitem.articleId !== null && pickitem.articleId !== '') && pickitem.barcode === null)) {
        error = true;
      }

      if ((pickitem.articleId === null || pickitem.articleId === '') && (pickitem.barcode === null || pickitem.barcode === '')) {
          warning = true;
      }

      if (productLocation !== tempLocation) {
        setProductLocation(tempLocation);

      }
      if (productDescription !== tempProductDescription) {
        setProductDescription(tempProductDescription);
      }
      if (tempAmountValue !== amountValue) {
        setAmountValue(tempAmountValue);
      }
      return (
        <Box className="card-box-content" style={{ background: error ? 'rgb(217, 150, 153)' : (warning && 'rgb(235, 187, 136)') }}>
          <Box className="card-box-info">
            <Box className="card-box-head">{t('Locatie')}: {tempLocation}</Box>
            <Box className="card-box-description" display="flex">
              <Box className="card-box-item-name" flexGrow="1">
                {tempProductDescription}
              </Box>
              <Box className="card-box-item-quantity"> {" " + tempAmountValue + " st"}</Box>
            </Box>
            {error && <Box style={{ paddingTop: '10px' }}>{t('Dit artikel bevat geen barcode, waarschuw een ploegchef.')}</Box>}
            {warning && <Box style={{ paddingTop: '10px' }}>{t('Subassembly nog niet beschikbaar, zet kar in wachtzone')}</Box>}
          </Box>
        </Box>
      );
    };
  }

  /* Render functions end*/

  const calculatePercentage = () => {
    var tempTotalAmount = 0;

    getListData.workflowSteps[0].workflowStepDetails.map((workflowStepDetail, index) => {
      let metaData = JSON.parse(workflowStepDetail.metaData);
      let amount = metaData[0].MetaData[0].Amount;
      tempTotalAmount += amount;
    });
    setTotalAmount(tempTotalAmount);
    return tempTotalAmount;
  };



  /* Calling getBycarrier Api */
  const getDataForCarrier = async (percentagePerItem) => {
    setshowLocation(props.location.state.listDetail.workflowSteps[0].workflowStepDetails[0].workflowProductDetailModel.location);
    setShowProductDescription(props.location.state.listDetail.workflowSteps[0].workflowStepDetails[0].workflowProductDetailModel.productReference);
    var tempCartNumber = showCartNumber();
    await dataService.getByCarrierBarcode(tempCartNumber).then((result) => {
      let getRecordChecked = getCompareListWithPauseDataList(result, percentagePerItem);
      if (getRecordChecked.length > 0) {
        setCheckeEndCartBtn(false);
        showProducts();
      }
      setCheckedList(getRecordChecked ? getRecordChecked : []);
    })
      .catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });
  };


  const getCompareListWithPauseDataList = (pickedStockItems, percentagePerItem) => {
    let progressPercentage = 0;
    var tempCheckedProducts = [...checkedProducts];
    var tempCheckedStock = [];

    var tempProductIdList = [...getProductIdList];
    var pickedItems = getListData.workflowSteps[0].workflowStepDetails.filter(x => x.finishedOn !== null);
    var tobePicked = getListData.workflowSteps[0].workflowStepDetails.filter(x => x.finishedOn === null);

    var indexPicked = false;
    getListData.workflowSteps[0].workflowStepDetails.map((workflowStepDetail, workflowStepDetailIndex) => {
      let workFlowStepDetailMetaData = JSON.parse(workflowStepDetail.metaData);
      tempProductIdList.push(workflowStepDetail.workflowProductDetailModel.productId);
      if (pickedStockItems === null || pickedStockItems.length === 0 || pickedStockItems === undefined || pickedStockItems === "") {
        indexPicked = true;
        setProductToBePickedIndex(workflowStepDetailIndex);
      }
      if (pickedStockItems.some(x => x.productId === workflowStepDetail.workflowProductDetailModel.productId)) {
        tempCheckedProducts[workflowStepDetailIndex] = true;
        tempCheckedStock.push(pickedStockItems.find(x => x.productId === workflowStepDetail.workflowProductDetailModel.productId).id);
        //Calculate the percentage this workflowstep holds of the whole picking procedure.
        var tempWorkFlowStepPercentage = handleProgressCalculation(workFlowStepDetailMetaData[0].MetaData[0].Amount, percentagePerItem, isNaN(getProgressPercentage) ? 0 : getProgressPercentage);
        progressPercentage += tempWorkFlowStepPercentage;
      } else if (indexPicked === false && !pickedStockItems.some(x => x.productId === workflowStepDetail.workflowProductDetailModel.productId)) {
        setProductToBePickedIndex(workflowStepDetailIndex);
        tempCheckedProducts[workflowStepDetailIndex] = false;
        indexPicked = true;
      } else if (workflowStepDetail.finishedOn === null) {
        tempCheckedProducts[workflowStepDetailIndex] = false;

      }
    });
    if (tempCheckedProducts.every(x => x.true)) {
      setProductToBePickedIndex(getListData.workflowSteps[0].workflowStepDetails.length);
    }
    setPickedStock(tempCheckedStock);
    setCheckedProducts(tempCheckedProducts);
    setProgressPercentage(progressPercentage);
    endCartButtonDeactivateOrActivate();

    return tempCheckedProducts;
  };

  const changeBarcode = (e) => {
    var barcodeValue = e.target.value;
    barcodeValue = barcodeValue.replace(/\s/g, '');
    setBarcode(barcodeValue);
  }


  const verifyProductId = (product_id) => {
    if (getProductIdList.length === 0) {
      return true;
    }
    else {
      return !getProductIdList.includes(product_id);
    }

  }

  const endCartButtonDeactivateOrActivate = () => {
    let flag = true;

    checkedProducts.map((item) => {
      if (item) {
        flag = false;
        //setEndCartBtnFlag(false);
        setCheckeEndCartBtn(false);
      } else {
        flag = true;
        //setEndCartBtnFlag(true);
      }
    });

    setEndCartBtnFlag(flag);
  };


  return (
    <Box
      display="flex"
      flexDirection="column"
      flexGrow="1"
      style={{ marginTop: 0, width: '100%', maxWidth: '100%' }}
    >
      <div className="section" >
        <div style={{ display: 'block', width: '100%', maxWidth: '100%', padding: 0, backgroundColor: "whitesmoke", borderBottom: '1px solid darkgrey', marginBottom: '10px' }}>
          <h3 className="heading" style={{ paddingLeft: '5px', paddingRight: '10px', paddingLeft: '10px' }}>{t('Picking lijst')}: {getListData.productionOrderReference} - {JSON.parse(getListData.productionOrderLineMetaData).find(x => x.MetaDataType === 2).MetaData[0].ItemNumber !== null && JSON.parse(getListData.productionOrderLineMetaData).find(x => x.MetaDataType === 2).MetaData[0].ItemNumber !== undefined && JSON.parse(getListData.productionOrderLineMetaData).find(x => x.MetaDataType === 2).MetaData[0].ItemNumber !== "" ? JSON.parse(getListData.productionOrderLineMetaData).find(x => x.MetaDataType === 2).MetaData[0].ItemNumber : getListData.reference}</h3>
        </div>
        <Box px={2} pb={2} display="flex" justifyContent="space-between">
          <Box flexGrow="1" pr={2}>
            <Box className="year">{t('Kar')}: {showCartNumber()}</Box>
            <Box className="progress">
              <Box
                className="progress-inner"
                style={{ width: `${getProgressPercentage}%`, maxWidth: "100%", color: getProgressPercentage === 0 ? 'black' : 'white' }}
              >
                {Math.round(getProgressPercentage)}%
              </Box>
            </Box>
          </Box>
          <Box>
            <Button variant="contained" size="small" className="btn-blue-changecart" onClick={() => goToScanner()}>
              {t('Wijzig kar')}
            </Button>
          </Box>
        </Box>
        <div className="scroller">
          <table className="table">
            <thead onClick={() => setShowTableList(!showTableList)}>
              <tr>
                <th style={{ width: '10%' }}>
                  <input type="checkbox" checked={checkedProducts.every(x => x)} readOnly className="pointer-event-none" />
                </th>
                <th style={{ width: '75%' }}>{t('Picking lijst')}</th>
                <th style={{ width: '15%' }}>
                  <span onClick={() => setShowTableList(!showTableList)} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {t('Aantal')} {!showTableList ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                  </span>
                </th>
              </tr>
            </thead>
            {showTableList &&
              <tbody>
                {showProducts()}
              </tbody>
            }
          </table>
        </div>
      </div>
      <Box px={2} style={{ paddingBottom: "50px" }}>
        <Box className="card-box" mt={4}>
          <Box className="card-box-heading">{t('Picking opdracht')}</Box>
          {showPickingAssignment()}
        </Box>

        <Box className="card-box" mt={4}>
          <Box className="card-box-heading">{t('Bevestig picking')}</Box>
          <Box className="card-box-content">
            <Box className="card-box-info">
              <Box mt={2} style={{ fontWeight: 600 }}>{t('Aantal stukken')}</Box>
              <Box display="flex" mb={3} mt={2}>
                <Box flexGrow="1" mt={2}>
                  <Input
                    fullWidth
                    variant="standard"
                    value={getCount}
                    type="number"
                    onChange={(e) => handleChangeCount(e)}
                  />
                </Box>
                <Box display="flex">
                  <Box>
                    <Button
                      variant="contained"
                      size="small"
                      className="btn-blue"
                      style={{ height: "70%" }}
                      onClick={() => handleSubtractCount()}
                    >
                      <RemoveIcon />
                    </Button>
                  </Box>
                  <Box ml={1}>
                    <Button
                      variant="contained"
                      size="small"
                      className="btn-blue"
                      style={{ height: "70%" }}
                      onClick={() => handleAddCount()}
                    >
                      <AddIcon />
                    </Button>
                  </Box>

                </Box>
              </Box>
              <div style={{ display: 'flex', marginBottom: '2rem' }}>
                <div style={{ width: '100%' }}>
                  <Box mt={0} style={{ fontWeight: 600 }}>{t('Barcode')}</Box>
                  <Box display="flex">
                    <Box flexGrow="1">
                      <div style={{ display: 'flex' }}>

                        <Input
                          // placeholder="Scan barcode"
                          placeholder={t("Barcode scannen")}
                          label=""
                          fullWidth
                          variant="standard"
                          value={barcode}
                          onChange={(e) => changeBarcode(e)}
                        />
                        <IconButton onClick={(event) => (popupEnable ? handleClickOpenScanner() : false)}>
                          <BiBarcodeReader></BiBarcodeReader>
                        </IconButton>
                      </div>
                    </Box>

                  </Box>

                </div>
                <Box display="flex">
                  <Box ml={1}>
                    <Button
                      variant="contained"
                      size="small"
                      className="btn-blue"
                      disabled={barcode === ""}
                      style={{ height: "100%", display: 'block', flexDirection: 'column' }}
                      onClick={(event) =>
                        popupItemEnable ? handleClickOpenItemDialog() : false
                      }
                    >
                      <Typography>
                        {t('Item')}
                      </Typography>
                      <Typography>{t('gepicked')}</Typography>
                    </Button>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box px={2} className="footer">
        <Button
          variant="contained"
          size="large"
          fullWidth
          className="btn-blue"
          onClick={(event) => getCheckeEndCartBtn ? handleGoBackToMainMenu()

            : (checkedProducts.every(checkedProduct => checkedProduct === true) ? handleClickOpenEndCartDialog()
              : handleClickOpenEndCartCompleteListDialog())
          }
        >
          {/* End Cart */}
          {/* {Math.round(getProgressPercentage) >= 100 ? "Beeïndig" : "Pauzeer"} */}
          {getCheckeEndCartBtn ? t('Terug naar overzicht') : (checkedProducts.every(checkedProduct => checkedProduct === true) ? t("Beeïndig") : t("Pauzeer"))}
        </Button>
      </Box>

      {/* Barcode Dialog  */}
      <Dialog
        open={openScanner}
        onClose={handleCloseScanner}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        className="barcode-scanner"
      >
        <DialogContent className="scanner">

          {scannerStarted && <React.Fragment>
            <div id="scanner-container" />
          </React.Fragment>}

        </DialogContent>
      </Dialog>

      {/* 2nd Dialog*/}
      <Dialog
        open={openItemPickedDialog}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t('Item gepicked')}</DialogTitle>
        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1" pb="10px">
            <b>{t('Product')}: </b>{productDescription}
          </Box>
          <Box flexGrow="1"><b>{t('Aantal')}: </b>{amountValue === 1 ? amountValue + ' ' + t("stuk") : amountValue + ' ' + t("stuks")}</Box>
        </DialogContent>

        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box pb={1} pt={1}>
            <button
              variant="contained"
              className="first-btn-blue"
              onClick={() => handleCloseItemDialog()}
            >
              {t('Corrigeren')}
            </button>
            <button
              type="submit"
              variant="contained"
              className="btn-blue"
              style={{ marginLeft: "10px" }}
              onClick={() => handleItemPicked()}
            >
              {t('Ok')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openQuantityDeficit}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img style={{ width: '30px', height: '30px' }} alt="done" src={process.env.PUBLIC_URL + '/img/warningIcon.png'}></img>{t('Waarschuwing')}</DialogTitle>
        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1">
            {t('Onvoldoende aantal')}! <br /> {t('Waarschuw een ploegchef')}.
          </Box>
        </DialogContent>

        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          {/* <Box pb={2} px={3} display="flex" justifyContent="end"> */}
          <button
            type="submit"
            variant="contained"
            className="btn-blue"
            onClick={() => handleOpenQuantityDeficit()}
          >
            {t('Annuleer')}
          </button>
          <button
            type="submit"
            variant="contained"
            className="btn-blue"
            style={{ marginLeft: "10px" }}
            onClick={() => handleClickOpenEndCartCompleteListDialog()}
          >
            {t('Pauzeer de kar')}
          </button>
          {/* </Box> */}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openQuantitySurplus}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img style={{ width: '30px', height: '30px' }} alt="done" src={process.env.PUBLIC_URL + '/img/warningIcon.png'}></img>{t('Waarschuwing')}</DialogTitle>
        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1">
            {t('Gelieve het correcte aantal te picken')}.
          </Box>
        </DialogContent>

        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          {/* <Box pb={2} px={3} display="flex" justifyContent="end"> */}
          <button
            type="submit"
            variant="contained"
            className="btn-blue"
            style={{ marginLeft: "10px" }}
            onClick={() => handleOpenQuantitySurplus()}
          >
            {t('Ok')}
          </button>
          {/* </Box> */}
        </DialogActions>
      </Dialog>

      {/* Credentials Dialog*/}
      <Dialog
        open={openEndCartDialogOne}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t('Inloggen als ploegchef')}</DialogTitle>

        <DialogContent dividers>
          <Box mb={3}>
            <TextField
              id="standard-basic"
              fullWidth
              // label="User Name"
              label={t("Gebruikersnaam")}
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </Box>
          <Box mb={3}>
            <TextField
              id="standard-basic"
              fullWidth
              type="password"
              // label="Password"
              label={t("Wachtwoord")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Box>
          <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                variant="contained"
                className="first-btn-blue"
                onClick={() => handleCloseEndCartDialogOne()}
              >
                {t('Terug')}
              </button>
              <button
                // onClick={handleSubmit}
                type="submit"
                variant="contained"
                className="btn-blue"
                style={{ marginLeft: "10px" }}
                onClick={() => handleWaitingZoneDialogOpen()}
              >
                {t('Ok')}
              </button>
            </Box>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* transfer zone Dialog*/}
      <Dialog
        open={openEndCartDialogSecond}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Kar beeïndigen</DialogTitle>

        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1" >
            {/* Put the cart in the transfer zone ? */}
            {t('Zet de kar in de transferzone')}
          </Box>
        </DialogContent>

        <DialogActions>
          <Box pb={2} px={2} display="flex" justifyContent="end">
            <button
              type="submit"
              variant="contained"
              disabled={debounceTimer}
              className="btn-blue"
              onClick={() => handleFinishedWorkflow()}
              style={{ transform: 'translate(-65px, 8px)' }}
            >
              {t('Ok')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Waiting zone Dialog*/}
      <Dialog
        open={openWaitingZoneDialog}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm">
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{t('Kar pauzeren')}</DialogTitle>

        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1">
            {/* Put the cart in the waiting zone ? */}
            {t('Zet de kar in de wachtzone')}?
          </Box>
        </DialogContent>

        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Box pb={1} px={2} display="flex">
            <button
              type="submit"
              variant="contained"
              className="btn-blue"
              onClick={() => handlePausedWorkflow()}
            >
              {t('Ok')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing warning that item could not be picked*/}
      <Dialog
        open={openItemNotPickedDialog}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img style={{ width: '30px', height: '30px' }} alt="done" src={process.env.PUBLIC_URL + '/img/warningIcon.png'}></img>{t('Waarschuwing')}</DialogTitle>

        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1">
            {/* Not enough stock */}
            {reasonItemNotPickedWrongBarcode ? (t("Er is geen voorraad gevonden met deze barcode die behoort tot dit item") + '.') : reasonItemNotPickedStockAmount ? t("Niet genoeg voorraad") : t("Item kan niet gepicked worden")}
          </Box>
        </DialogContent>

        <DialogActions
          style={{ transform: "translate(-2px, -5px)", padding: "13px 60px" }}
        >
          <Box px={2} display="flex" justifyContent="end">
            <button
              type="submit"
              variant="contained"
              className="btn-blue"
              onClick={() => handleItemNotPickedDialogClose()}
            >
              {t('Ok')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing warning that User verification failed*/}
      <Dialog
        open={openVerificationDialog}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogContent style={{ textAlign: "center" }}>
          <Box className="card-box-item-name" flexGrow="1">
            {/* Incorrect username or password, Please try again . */}
            {t('Incorrecte gebruikersnaam of wachtwoord. Probeer alstublieft opnieuw')}.
          </Box>
        </DialogContent>

        <DialogActions
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <Box pb={1} px={1} display="flex" justifyContent="center">
            <button
              type="submit"
              variant="contained"
              className="btn-blue"
              onClick={() => setOpenVerificationDialog(false)}
            >
              {t('Ok')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* When all items get picked */}
      <Dialog
        open={openDialogWhenAllItemsPicked}
        aria-labelledby="alert-dialog-title2"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Picking compleet</DialogTitle>

        <DialogContent style={{ textAlign: "center" }} dividers>
          <Box className="card-box-item-name" flexGrow="1" pb="10px">
            {t('Alle materialen zijn gepicked')}.
          </Box>
          <Box className="card-box-item-name" flexGrow="1">
            <b>{t('Deze kar wordt afgesloten')}.</b>
          </Box>
        </DialogContent>

        <DialogActions
          style={{ transform: "translate(-90px, -5px)", padding: "13px 60px" }}
        >
          <Box pb={1} px={2} display="flex" justifyContent="end">
            <button
              type="submit"
              variant="contained"
              className="btn-blue"
              onClick={() => handleClickOpenEndCartDialog()}
              style={{ transform: 'translate(86px, 3px)' }}
            >
              {t('Beeïndig')}
            </button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default PickingDetail;
